import { create } from 'zustand';

import type { AuthenticatedUser } from './types';

interface UserState {
  user: AuthenticatedUser | null;
}

/**
 * Thin Zustand store holding the signed-in user as a plain domain entity.
 *
 * Single writer: `app/store/auth` calls `setCurrentUser` (from
 * `entities/user/internal/bridge`) after a successful `signIn()`. Multiple
 * readers: any layer at `widgets`/`features`/`entities` level reads via the
 * selectors in `entities/user/api/user.selectors`.
 *
 * Auth lifecycle (fetching/error/permissions) stays in `app/store/auth` —
 * this store only carries the resolved domain entity.
 *
 * No `setUser` action is exposed on the store: the only writer is the
 * internal bridge, which calls `useUserStore.setState({ user })` directly.
 * This keeps the public store surface read-only.
 */
export const useUserStore = create<UserState>(() => ({
  user: null,
}));
